<template>
  <div class="goods meeting">
    <v-head :title="title"></v-head>
    <div class="voteBox">
      <div class="voteDiv">
        <h4>{{ electionRelease.name }}</h4>
        <div class="butBox">
          <!-- <div>
            <van-button type="primary" size="mini">多选</van-button>
            <van-button type="danger" size="mini">绝对多数复选制</van-button>
          </div> -->
          <b
            >已参与人数：{{
              electionRelease.visitors ? electionRelease.visitors : 0
            }}人</b
          >
        </div>
        <div class="introduce">
          <p class="m-content overflow-line" id="J_description">
            {{ electionRelease.content }}
          </p>
          <div
            class="btn-more"
            v-if="isShowMore"
            id="J_btnmore"
            @click="showmoreDesc($event)"
          >
            展开查看更多
          </div>
        </div>
      </div>
      <p class="timeDjs">投票倒计时：{{ countDown }}</p>
      <van-divider>投票结果</van-divider>
      <div class="listRodio">
        <ul>
          <li  v-for="(item, index) in candidateList" :key="index">
            <div>
              <h4 v-if="item.contentType == 1">{{item.name}}</h4>
              <h4 v-if="item.contentType == 2">{{item.content}}</h4>
              <span>{{item.voteTotal?item.voteTotal:'0'}}票</span>
            </div>
            <van-progress :percentage="item.voteTotal?item.voteTotal:'0'" stroke-width="30" color="#ee0a24"  v-if="item.voteTotal&&item.voteTotal>50"/>
            <van-progress :percentage="item.voteTotal?item.voteTotal:'0'" stroke-width="30" v-else-if="item.voteTotal&&item.voteTotal>0"/>
            <van-progress :percentage="item.voteTotal?item.voteTotal:'0'" stroke-width="30" inactive  v-else/>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script>
import vHead from "../../components/Subhead.vue";
import {
  Button,
  Divider,
  List,
  CountDown,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Toast,
  Progress
} from "vant";
import { mapGetters, mapState, mapActions } from "vuex";
import {
  getCandidateList,
  getElectionReleaseInfo,
} from "@/api/dictionary";
import { getSessionStore } from "@/utils/sessionStorage.js";
export default {
  data() {
    return {
      isShowMore: false,
      isDescStatus: true,
      countDown: null,
      navActive: 3,
      page: -1,
      list:[],
      title: "投票结果",
      result: [],
      candidateList: [],
      minTimes: 1,
      maxTimes: 1,
      voteInfoTimesNum: "",
      electionRelease: {
        name: "",
        startTime: null,
        endTime: null,
        times: null,
        minTimes: null,
        maxTimes: null,
        visitors: null,
        contentType: null,
        isVote: null,
        type: null,
      },
    };
  },
  components: {
    vHead,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [List.name]: List,
    [CountDown.name]: CountDown,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Toast.name]: Toast,
    [Progress.name]:Progress
  },
  methods: {
    ...mapActions(["getGroupMemberType", "getPersonMemberType"]),
    goPath(pathName) {
      this.$router.push({ name: pathName });
    },
    changActive(val) {
      this.navActive = val;
    },
    showmoreDesc(e) {
      let el = e.currentTarget;
      el.previousElementSibling.classList[
        !this.isDescStatus ? "add" : "remove"
      ]("overflow-line");
      el.classList[this.isDescStatus ? "add" : "remove"]("more-collapse");
      el.innerHTML = !this.isDescStatus ? "展开查看更多" : "收起";
      this.isDescStatus = !this.isDescStatus;
      this.isShowMore = true;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    getData() {
      let params = {
        electionId: this.electionRelease.id,
        contentType: this.electionRelease.contentType,
      };
      getCandidateList(params).then((res) => {
        if (res.success) {
          this.candidateList = res.result;
        }
      });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    id() {
      return this.$route.query && this.$route.query.id;
    },
  },
  mounted() {
    getElectionReleaseInfo({ id: this.id }).then((res) => {
      if (res.success) {
        this.electionRelease = res.result;
        if (this.electionRelease.startTime) {
          setInterval(() => {
            var aaa = new Date(this.electionRelease.startTime.replace(/-/g, '/')).getTime();
            var bbb = new Date().getTime();
            let endTime = new Date(this.electionRelease.endTime.replace(/-/g, '/')).getTime();
            if(aaa < bbb < endTime){
              this.countDown = "投票进行中";
            }
            // if (aaa == bbb) {
            //   this.countDown = "投票进行中";
            //   return;
            // }
            if (endTime < bbb) {
              this.countDown = "投票已经结束";
              return;
            }
            var rightTime = endTime - bbb;
            if (rightTime > 0) {
              var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
              var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
              var mm = Math.floor((rightTime / 1000 / 60) % 60);
              var ss = Math.floor((rightTime / 1000) % 60);
            }
            this.countDown = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
          }, 1000);
        }
        if (this.electionRelease.content.length > 75) {
          this.isShowMore = true;
        }
        if (this.electionRelease.type == 1) {
          this.minTimes = 1;
          this.maxTimes = 1;
        } else {
          this.minTimes = this.electionRelease.minTimes;
          this.maxTimes = this.electionRelease.maxTimes;
        }
        this.getData();
      }
    });
  },
};
</script>

<style lang="less" scoped>
.meeting /deep/.van-nav-bar__title,
.meeting /deep/.van-nav-bar__text {
  color: #000 !important;
}
.meeting /deep/.sign_out {
  color: #000 !important;
}
.voteBox {
  background: #fafafa;
  padding: 20px 4%;
  position: fixed;
  height: 88%;
  overflow-y: scroll;
  width: 92%;
}
.butBox {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  align-items: center;
  margin: 10px 0;
}
.butBox span {
  font-size: 12px;
}
.voteBox>ul {
  margin-bottom: 136px;
}
.voteBox > div.voteDiv,
.listRodio {
  border: #ddd solid 1px;
  border-radius: 5px;
  padding: 15px;
  background: #fff;
  margin-bottom: 15px;
}
.listRodio li>div{ display: flex; justify-content: space-between; margin-bottom: 10px;}
.listRodio li>div *{ font-size: 16px;}
.voteBox > div.voteDiv h4 {
  color: #000;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.voteBox ul li > div {
  font-size: 12px;
}
.voteBox ul li > div b {
  margin-right: 10px;
}

.m-content {
  font-size: 14px;
  line-height: 20px;
  &.overflow-line {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
.btn-more {
  text-align: center;
  color: #107bdb;
  font-size: 14px;
  margin-top: 10px;
}
.timeDjs {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.listRodio > p {
  font-size: 14px;
  margin-bottom: 10px;
}
/deep/.van-progress__pivot{ left: initial!important; line-height: 30px; border-radius:5px!important;}
</style>
